export const abi = [
  {
    type: 'error',
    name: 'ActionAlreadyProcessed',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'previousId',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'lastCompleteId',
        type: 'uint64',
        internalType: 'ActionId',
      },
    ],
  },
  {
    type: 'error',
    name: 'ActionExpired',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'blockTime',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'signedAt',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: 'buffer',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
  },
  {
    type: 'error',
    name: 'AlreadyInitialized',
    inputs: [],
  },
  {
    type: 'error',
    name: 'DelegationFailed',
    inputs: [],
  },
  {
    type: 'error',
    name: 'DepositCapacityExceeded',
    inputs: [
      {
        name: 'capacity',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'DepositInsufficient',
    inputs: [
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'EmptyActions',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ExcludedAccount',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'FeeNotCoveredByBalance',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
  },
  {
    type: 'error',
    name: 'InsufficientBalance',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'balance',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidAction',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'actionType',
        type: 'uint8',
        internalType: 'enum ActionType',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidCost',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'cost',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidDepositToken',
    inputs: [
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidEngineType',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'engineType',
        type: 'uint8',
        internalType: 'enum EngineType',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidInitialization',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidMatchZeroQuantity',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'makerFillableQty',
        type: 'uint128',
        internalType: 'uint128',
      },
      {
        name: 'takerFillableQty',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidNonce',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'nonce',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidOrderPrice',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'price',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidOrderPriceNotCrossed',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'makerPrice',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'takerPrice',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidOrderProductMismatch',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidOrderQuantity',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'quantity',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidOrderSameSide',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'side',
        type: 'uint8',
        internalType: 'enum OrderSide',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidOrderZeroPrice',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidParameter',
    inputs: [
      {
        name: 'parameter',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'reason',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidReduceOnlyFill',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'positionSize',
        type: 'int128',
        internalType: 'int128',
      },
      {
        name: 'sizeDelta',
        type: 'int128',
        internalType: 'int128',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidRegistryRecord',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidSignature',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'signer',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'signature',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidSigner',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'signer',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'LiquidateAboveMaintenanceMargin',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'remainingMargin',
        type: 'int256',
        internalType: 'int256',
      },
      {
        name: 'requiredMaintenanceMargin',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'LiquidateEmptyProducts',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'LiquidateProductsMismatch',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'openPositions',
        type: 'uint128',
        internalType: 'uint128',
      },
      {
        name: 'products',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
  },
  {
    type: 'error',
    name: 'LiquidateSizeNotNetZero',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'sizeDelta',
        type: 'int128',
        internalType: 'int128',
      },
      {
        name: 'netSize',
        type: 'int128',
        internalType: 'int128',
      },
    ],
  },
  {
    type: 'error',
    name: 'LiquidateZeroMargin',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'NewOwnerIsZeroAddress',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NoHandoverRequest',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NotInitializing',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NotSequencer',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'PendingDepositFound',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'PendingDepositMismatch',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'PendingDepositNotFound',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'PriceInvalidExponent',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'exponent',
        type: 'int16',
        internalType: 'int16',
      },
    ],
  },
  {
    type: 'error',
    name: 'PriceInvalidFeedId',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'priceFeedId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'productFeedId',
        type: 'uint32',
        internalType: 'uint32',
      },
    ],
  },
  {
    type: 'error',
    name: 'PriceTooOld',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'priceTimestamp',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: 'timestamp',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
  },
  {
    type: 'error',
    name: 'ProductNotFound',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'engineType',
        type: 'uint8',
        internalType: 'enum EngineType',
      },
    ],
  },
  {
    type: 'error',
    name: 'ProductStatusViolation',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'engineType',
        type: 'uint8',
        internalType: 'enum EngineType',
      },
      {
        name: 'status',
        type: 'uint8',
        internalType: 'enum ProductStatus',
      },
    ],
  },
  {
    type: 'error',
    name: 'SequencerPaused',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'SignerDepositUnauthorized',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'SignerNotFound',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'signer',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'SubaccountNotFound',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'TokenDepositPaused',
    inputs: [
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'TokenRemoveProtected',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'TokenWithdrawPaused',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'Unauthorized',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UnauthorizedAccount',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'UnauthorizedCallContext',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UpgradeFailed',
    inputs: [],
  },
  {
    type: 'error',
    name: 'WithdrawFound',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'WithdrawNotFound',
    inputs: [],
  },
  {
    type: 'error',
    name: 'WithdrawNotReady',
    inputs: [
      {
        name: 'validAfterTimestamp',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'ZeroAmount',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ZeroLength',
    inputs: [],
  },
  {
    type: 'event',
    name: 'AccountReferred',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'referralCode',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'ActionExpiryBufferUpdated',
    inputs: [
      {
        name: 'action',
        type: 'uint8',
        indexed: true,
        internalType: 'enum ActionType',
      },
      {
        name: 'buffer',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'DepositFinalized',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'balance',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'initiatedTxHash',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
      {
        name: 'initiatedLogIdx',
        type: 'uint8',
        indexed: false,
        internalType: 'uint8',
      },
      {
        name: 'messageIdx',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'DepositInitiated',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FeeAccrued',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'feeAmount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'balance',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FeeCollectorUpdated',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FeesClaimed',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Initialized',
    inputs: [
      {
        name: 'version',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'LiquidatorUpdated',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OwnershipHandoverCanceled',
    inputs: [
      {
        name: 'pendingOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OwnershipHandoverRequested',
    inputs: [
      {
        name: 'pendingOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OwnershipTransferred',
    inputs: [
      {
        name: 'oldOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'newOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpOrderMatched',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'maker',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'taker',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'makerSubaccount',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
      {
        name: 'takerSubaccount',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
      {
        name: 'makerSide',
        type: 'uint8',
        indexed: false,
        internalType: 'enum OrderSide',
      },
      {
        name: 'takerSide',
        type: 'uint8',
        indexed: false,
        internalType: 'enum OrderSide',
      },
      {
        name: 'fillQuantity',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'price',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'messageIdx',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductFeesUpdated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'makerFee',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'takerFee',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductFundingUpdated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'fundingUsd',
        type: 'int256',
        indexed: false,
        internalType: 'int256',
      },
      {
        name: 'cumulativeFundingUsd',
        type: 'int256',
        indexed: false,
        internalType: 'int256',
      },
      {
        name: 'messageIdx',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductMaxLeverageUpdated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'maxLeverage',
        type: 'uint16',
        indexed: false,
        internalType: 'uint16',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductMaxOpenInterestUpdated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'previousMaxOpenInterest',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'maxOpenInterest',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductRegistered',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'baseTokenName',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
      {
        name: 'quoteTokenName',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductSizesUpdated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'tickSize',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'maxQuantity',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PerpProductStatusUpdated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'oldStatus',
        type: 'uint8',
        indexed: false,
        internalType: 'enum ProductStatus',
      },
      {
        name: 'newStatus',
        type: 'uint8',
        indexed: false,
        internalType: 'enum ProductStatus',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PositionLiquidated',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'liquidatedAccount',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'liquidatedSubaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'engineType',
        type: 'uint8',
        indexed: false,
        internalType: 'enum EngineType',
      },
      {
        name: 'size',
        type: 'int128',
        indexed: false,
        internalType: 'int128',
      },
      {
        name: 'messageIdx',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PositionTransferred',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        indexed: true,
        internalType: 'uint32',
      },
      {
        name: 'engineType',
        type: 'uint8',
        indexed: true,
        internalType: 'enum EngineType',
      },
      {
        name: 'accountFrom',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'subaccountFrom',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
      {
        name: 'accountTo',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'subaccountTo',
        type: 'bytes32',
        indexed: false,
        internalType: 'bytes32',
      },
      {
        name: 'amount',
        type: 'int128',
        indexed: false,
        internalType: 'int128',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PythLazerUpdated',
    inputs: [
      {
        name: 'pythLazer',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'maxAge',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RegistryRecordUpdated',
    inputs: [
      {
        name: 'name',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'record',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SequencerAdded',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SequencerPausedUpdated',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'paused',
        type: 'bool',
        indexed: false,
        internalType: 'bool',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SequencerRemoved',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SignerLinkRejected',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'signer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'linkedTimestamp',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SignerLinked',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'signer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'linkedTimestamp',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SignerRevoked',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'signer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'TokenAdded',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'tokenAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'TokenPromoted',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'tokenAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'TokenRemoved',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'tokenAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'TokenUpdated',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'tokenAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Upgraded',
    inputs: [
      {
        name: 'implementation',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'WithdrawFinalized',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'WithdrawInitiated',
    inputs: [
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint128',
        indexed: false,
        internalType: 'uint128',
      },
      {
        name: 'messageIdx',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'WithdrawLockoutUpdated',
    inputs: [
      {
        name: 'period',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'function',
    name: 'INITIATE_WITHDRAW_ABI_PARAM',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'LINK_SIGNER_ABI_PARAM',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'REVOKE_LINKED_SIGNER_ABI_PARAM',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'TRADE_ORDER_ABI_PARAM',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'UPDATE_FUNDING_ABI_PARAM',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'addSequencer',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'addToken',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'tokenAddress',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'cancelOwnershipHandover',
    inputs: [],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'claimFees',
    inputs: [
      {
        name: 'feeToken',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'completeOwnershipHandover',
    inputs: [
      {
        name: 'pendingOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'deposit',
    inputs: [
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'depositToken',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'referralCode',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'eip712Domain',
    inputs: [],
    outputs: [
      {
        name: 'fields',
        type: 'bytes1',
        internalType: 'bytes1',
      },
      {
        name: 'name',
        type: 'string',
        internalType: 'string',
      },
      {
        name: 'version',
        type: 'string',
        internalType: 'string',
      },
      {
        name: 'chainId',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'verifyingContract',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'salt',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'extensions',
        type: 'uint256[]',
        internalType: 'uint256[]',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'executeMatch',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'action',
        type: 'tuple',
        internalType: 'struct IExchangeGateway.MatchOrdersAction',
        components: [
          {
            name: 'maker',
            type: 'tuple',
            internalType: 'struct IExchangeGateway.TradeOrder',
            components: [
              {
                name: 'sender',
                type: 'address',
                internalType: 'address',
              },
              {
                name: 'subaccount',
                type: 'bytes32',
                internalType: 'bytes32',
              },
              {
                name: 'quantity',
                type: 'uint128',
                internalType: 'uint128',
              },
              {
                name: 'price',
                type: 'uint128',
                internalType: 'uint128',
              },
              {
                name: 'reduceOnly',
                type: 'bool',
                internalType: 'bool',
              },
              {
                name: 'side',
                type: 'uint8',
                internalType: 'enum OrderSide',
              },
              {
                name: 'engineType',
                type: 'uint8',
                internalType: 'enum EngineType',
              },
              {
                name: 'productId',
                type: 'uint32',
                internalType: 'uint32',
              },
              {
                name: 'nonce',
                type: 'uint64',
                internalType: 'uint64',
              },
              {
                name: 'signedAt',
                type: 'uint64',
                internalType: 'uint64',
              },
            ],
          },
          {
            name: 'taker',
            type: 'tuple',
            internalType: 'struct IExchangeGateway.TradeOrder',
            components: [
              {
                name: 'sender',
                type: 'address',
                internalType: 'address',
              },
              {
                name: 'subaccount',
                type: 'bytes32',
                internalType: 'bytes32',
              },
              {
                name: 'quantity',
                type: 'uint128',
                internalType: 'uint128',
              },
              {
                name: 'price',
                type: 'uint128',
                internalType: 'uint128',
              },
              {
                name: 'reduceOnly',
                type: 'bool',
                internalType: 'bool',
              },
              {
                name: 'side',
                type: 'uint8',
                internalType: 'enum OrderSide',
              },
              {
                name: 'engineType',
                type: 'uint8',
                internalType: 'enum EngineType',
              },
              {
                name: 'productId',
                type: 'uint32',
                internalType: 'uint32',
              },
              {
                name: 'nonce',
                type: 'uint64',
                internalType: 'uint64',
              },
              {
                name: 'signedAt',
                type: 'uint64',
                internalType: 'uint64',
              },
            ],
          },
          {
            name: 'makerSignature',
            type: 'bytes',
            internalType: 'bytes',
          },
          {
            name: 'takerSignature',
            type: 'bytes',
            internalType: 'bytes',
          },
          {
            name: 'makerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'takerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'messageIdx',
            type: 'uint64',
            internalType: 'uint64',
          },
        ],
      },
      {
        name: 'digests',
        type: 'tuple',
        internalType: 'struct IPerpEngine.ExecuteMatchDigests',
        components: [
          {
            name: 'maker',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'taker',
            type: 'bytes32',
            internalType: 'bytes32',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'finalizeWithdraw',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'getAccountBalance',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getAccountGlobalTotalBalance',
    inputs: [
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getAccountGlobalTotalPendingBalance',
    inputs: [
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getAccountGlobalUsdToken',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getActionExpiryBuffer',
    inputs: [
      {
        name: 'action',
        type: 'uint8',
        internalType: 'enum ActionType',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getExchangePythLazer',
    inputs: [],
    outputs: [
      {
        name: 'pythLazer',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'pythMaxAge',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getExchangeSequencer',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: 'isApproved',
        type: 'bool',
        internalType: 'bool',
      },
      {
        name: 'isPaused',
        type: 'bool',
        internalType: 'bool',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getExchangeTokens',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32[]',
        internalType: 'bytes32[]',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getExchangeWithdrawLockout',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getFeeCollector',
    inputs: [],
    outputs: [
      {
        name: 'feeCollectorAccount',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'feeCollectorSubaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getLinkedSignerAccount',
    inputs: [
      {
        name: 'linkedSigner',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getLiquidator',
    inputs: [],
    outputs: [
      {
        name: 'liquidatorAccount',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'liquidatorSubaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getPendingDeposit',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct Deposit.Data',
        components: [
          {
            name: 'token',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'fee',
            type: 'uint128',
            internalType: 'uint128',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getPerpPosition',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct PerpPosition.Data',
        components: [
          {
            name: 'size',
            type: 'int128',
            internalType: 'int128',
          },
          {
            name: 'cost',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'lastFundingUsd',
            type: 'int128',
            internalType: 'int128',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getPerpProduct',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct PerpProduct.Info',
        components: [
          {
            name: 'id',
            type: 'uint32',
            internalType: 'uint32',
          },
          {
            name: 'status',
            type: 'uint8',
            internalType: 'enum ProductStatus',
          },
          {
            name: 'baseTokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'quoteTokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'makerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'takerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'tickSize',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'maxQuantity',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'lotSize',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'openInterest',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'cumulativeFundingUsd',
            type: 'int128',
            internalType: 'int128',
          },
          {
            name: 'maxLeverage',
            type: 'uint16',
            internalType: 'uint16',
          },
          {
            name: 'maxOpenInterest',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'pythFeedId',
            type: 'uint32',
            internalType: 'uint32',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getToken',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct Token.Data',
        components: [
          {
            name: 'tokenAddress',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'depositCapacity',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'minDeposit',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'withdrawFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'depositFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'depositEnabled',
            type: 'bool',
            internalType: 'bool',
          },
          {
            name: 'withdrawEnabled',
            type: 'bool',
            internalType: 'bool',
          },
          {
            name: 'removeProtected',
            type: 'bool',
            internalType: 'bool',
          },
        ],
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'getWithdraw',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct Withdraw.Data',
        components: [
          {
            name: 'token',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'fee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'initiatedAt',
            type: 'uint64',
            internalType: 'uint64',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'initialize',
    inputs: [],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'liquidateSubaccount',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'actionData',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'owner',
    inputs: [],
    outputs: [
      {
        name: 'result',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'ownershipHandoverExpiresAt',
    inputs: [
      {
        name: 'pendingOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: 'result',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'processActions',
    inputs: [
      {
        name: 'actions',
        type: 'bytes[]',
        internalType: 'bytes[]',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'promoteToken',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'tokenAddress',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'proxiableUUID',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'register',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IPerpEngine.RegisterPerpProductParams',
        components: [
          {
            name: 'status',
            type: 'uint8',
            internalType: 'enum ProductStatus',
          },
          {
            name: 'baseTokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'quoteTokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'makerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'takerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'tickSize',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'maxQuantity',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'lotSize',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'maxLeverage',
            type: 'uint16',
            internalType: 'uint16',
          },
          {
            name: 'maxOpenInterest',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'pythFeedId',
            type: 'uint32',
            internalType: 'uint32',
          },
        ],
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint32',
        internalType: 'uint32',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'registerPerpProduct',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IPerpEngine.RegisterPerpProductParams',
        components: [
          {
            name: 'status',
            type: 'uint8',
            internalType: 'enum ProductStatus',
          },
          {
            name: 'baseTokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'quoteTokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'makerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'takerFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'tickSize',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'maxQuantity',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'lotSize',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'maxLeverage',
            type: 'uint16',
            internalType: 'uint16',
          },
          {
            name: 'maxOpenInterest',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'pythFeedId',
            type: 'uint32',
            internalType: 'uint32',
          },
        ],
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint32',
        internalType: 'uint32',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'removeSequencer',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'removeToken',
    inputs: [
      {
        name: 'tokenName',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'renounceOwnership',
    inputs: [],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'requestOwnershipHandover',
    inputs: [],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'transferOwnership',
    inputs: [
      {
        name: 'newOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'updateActionExpiryBuffer',
    inputs: [
      {
        name: 'action',
        type: 'uint8',
        internalType: 'enum ActionType',
      },
      {
        name: 'buffer',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateFeeCollector',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateFees',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'makerFee',
        type: 'uint128',
        internalType: 'uint128',
      },
      {
        name: 'takerFee',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateFunding',
    inputs: [
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'fundingDeltaUsd',
        type: 'int128',
        internalType: 'int128',
      },
      {
        name: 'messageIdx',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateLiquidator',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'subaccount',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateMaxLeverage',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'maxLeverage',
        type: 'uint16',
        internalType: 'uint16',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateMaxOpenInterest',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'maxOpenInterest',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePerpProductFees',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'makerFee',
        type: 'uint128',
        internalType: 'uint128',
      },
      {
        name: 'takerFee',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePerpProductMaxLeverage',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'maxLeverage',
        type: 'uint16',
        internalType: 'uint16',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePerpProductMaxOpenInterest',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'maxOpenInterest',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePerpProductSizes',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'tickSize',
        type: 'uint128',
        internalType: 'uint128',
      },
      {
        name: 'maxQuantity',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePerpProductStatus',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'status',
        type: 'uint8',
        internalType: 'enum ProductStatus',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePythLazer',
    inputs: [
      {
        name: 'updatedContract',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'updatedMaxAge',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateRegistryRecord',
    inputs: [
      {
        name: 'name',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'record',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateSequencerPaused',
    inputs: [
      {
        name: 'sequencer',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'paused',
        type: 'bool',
        internalType: 'bool',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateSizes',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'tickSize',
        type: 'uint128',
        internalType: 'uint128',
      },
      {
        name: 'maxQuantity',
        type: 'uint128',
        internalType: 'uint128',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateStatus',
    inputs: [
      {
        name: 'productId',
        type: 'uint32',
        internalType: 'uint32',
      },
      {
        name: 'status',
        type: 'uint8',
        internalType: 'enum ProductStatus',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateToken',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IExchangeConfig.UpdateTokenParams',
        components: [
          {
            name: 'tokenName',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'depositCapacity',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'minDeposit',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'depositFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'withdrawFee',
            type: 'uint128',
            internalType: 'uint128',
          },
          {
            name: 'depositEnabled',
            type: 'bool',
            internalType: 'bool',
          },
          {
            name: 'withdrawEnabled',
            type: 'bool',
            internalType: 'bool',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateWithdrawLockout',
    inputs: [
      {
        name: 'period',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'upgradeToAndCall',
    inputs: [
      {
        name: 'newImplementation',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'data',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'verifySignature',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'digest',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'signature',
        type: 'bytes',
        internalType: 'bytes',
      },
      {
        name: 'id',
        type: 'uint64',
        internalType: 'ActionId',
      },
    ],
    outputs: [],
    stateMutability: 'view',
  },
] as const;
